/* DSL Hero scroll animation — fade content as user scrolls past hero */
(function(){
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) return;
  var heroes = document.querySelectorAll(".hero-banner, .image-banner, [data-hero-fade]");
  if (!heroes.length) return;
  function onScroll(){
    heroes.forEach(function(h){
      var rect = h.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, 1 - (rect.bottom / window.innerHeight)));
      var content = h.querySelector(".hero-banner__content, .image-banner__content, [data-hero-content]");
      if (content) content.style.opacity = String(1 - pct);
    });
  }
  var ticking = false;
  window.addEventListener("scroll", function(){
    if (!ticking) { requestAnimationFrame(function(){ onScroll(); ticking = false; }); ticking = true; }
  }, {passive: true});
})();